/**
 * related-products
 */
import 'slick-carousel';
import 'jquery-match-height';

// Module styles
import './_related-item-card.scss';

// Module template
import './_related-item-card.twig';

export const name = 'related-items';

export const defaults = {
  dummyClass: 'js-related-items-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */

export function disable() {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
(function ($, $context, { relatedItems = {} } = {}) {
  // Find our component within the DOM
  const $relatedItems = $('.related-items', $context);
  const $relatedItemsMenu = $('.related-items-menu', $context);
  // Bail if component does not exist
  if (!$relatedItems.length && !$relatedItemsMenu.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...relatedItems,
  };
  // An example of what could be done with this component
  $relatedItems.addClass(settings.dummyClass);

  function initCarousel($carouselWrapper) {
    $carouselWrapper.slick({
      infinite: false,
      speed: 300,
      arrows: true,
      mobileFirst: true,
      accessibility: true,
      cssEase: 'ease',
      respondTo: 'window',
      touchMove: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
      ],
    });
  }

  function updateHeight($item) {
    // Match height for img.
    $item.find('.related-item-card').matchHeight({
      byRow: false,
      property: 'height',
      target: null,
      remove: false,
    });
  }

  // Initiate slick
  $relatedItems.each(function initiateSlick(i, el) {
    const $relatedItem = $(el);
    if (window.matchMedia('(min-width: 768px)').matches) {
      // Create an Intersection Observer instance
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // If slick is initialized then just refresh it to
            // avoid broken when switching between sliders
            if ($(entry.target).hasClass('slick-initialized')) {
              $relatedItem.slick('refresh');
              updateHeight($relatedItem);
            } else {
              initCarousel($relatedItem);
              updateHeight($relatedItem);
            }

            // If less than 4 products are tagged set
            // width to 100% by adding the class w-full
            if ($relatedItem.data('slide-count') < 4) {
              $relatedItem.find('.slick-track').addClass('w-full');
            }
          }
        });
      });
      // Start observing the "related-item" slider element
      observer.observe($(this)[0]);
    } else {
      $(el).find('.related-item-card').slice(0, 4).show();
      $(el)
        .siblings('.see-more')
        .find('a')
        .on('click', function (e) {
          e.preventDefault();
          $(el).find('.related-item-card:hidden').slice(0, 4).slideDown();
          if (!$(el).find('.related-item-card:hidden').length) {
            $(el).siblings('.see-more').hide();
          }
        });
    }

    $relatedItem.on(
      'click',
      '.related-item-card__show_more_button span',
      function () {
        $(this).toggleClass('d-none');
        $(this).siblings('span').toggleClass('d-none');
        $(this).parent().toggleClass('icon-rotate');
        $(this)
          .parent()
          .siblings('.related-item-card__content')
          .toggleClass('show-attributes');
      }
    );
  });

  // To show and hide related accessories data on click
  const $relatedItemMenu = $('.dropdown-content li a');
  $relatedItemMenu.each(function () {
    $relatedItemMenu.click(function (e) {
      e.preventDefault();
      const target = `#${$(this).data('target')}`;
      $('.dropdown-content li a.active').removeClass('active');
      $(this).addClass('active');
      $('.related-items-menu-content > div').not(target).addClass('hide');
      $(target).removeClass('hide');
    });
  });

  // on window for desktop remove hide class from
  // first element to display data
  const windowSize = window.innerWidth;
  if (windowSize > 720) {
    const $relatedMenuContent = $(
      '.related-items-menu-content div:first-child'
    );
    $relatedMenuContent.removeClass('hide');
  }

  function handleDropdowns() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 720) {
      // related table select action dropdown list
      document.addEventListener('click', function (event) {
        const relatedActionsLists = document.querySelectorAll(
          '.related-actions-list'
        );
        relatedActionsLists.forEach(function (relatedActionsList) {
          const dropdownContent = relatedActionsList.querySelector(
            '.dropdown-content'
          );
          if (
            dropdownContent &&
            event.target !== relatedActionsList &&
            !event.target.closest('.dropdown-content')
          ) {
            dropdownContent.style.display = 'none';
          }
        });
        const relatedActionsList = event.target.closest(
          '.related-actions-list'
        );
        if (relatedActionsList) {
          const dropdownContent = relatedActionsList.querySelector(
            '.dropdown-content'
          );
          if (dropdownContent) {
            dropdownContent.style.display =
              dropdownContent.style.display === 'block' ? 'none' : 'block';
            relatedActionsList.classList.add('active');
          }
        }
      });

      // Handle click on a dropdown item
      document.addEventListener('click', function (event) {
        if (event.target.tagName === 'A') {
          const selectedValue = event.target.textContent;
          const relatedActionsList = event.target.closest(
            '.related-actions-list'
          );
          if (relatedActionsList) {
            relatedActionsList.querySelector(
              'span'
            ).textContent = selectedValue;
            relatedActionsList.querySelector(
              '.dropdown-content'
            ).style.display = 'none';
            relatedActionsList.querySelector('p').classList.add('active');
          }
        }
      });
    }
  }
  // Call the function initially and listen for window resize events
  handleDropdowns();
  window.addEventListener('resize', handleDropdowns);
})(jQuery);
